import { AfterViewInit, Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AccordionComponent, DropdownSelectComponent } from '@ppl/ui';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ENROLLMENT_TYPE_BACKEND_MAPPINGS, ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS, formMasterIdMap } from '../../../../shared/constants/static-data.constants';
import { Program } from '../../../../interfaces/user.interface';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { SectionsService } from '../../../../services/sections.service';
import { EnrollmentSummaryResponseItem, ProviderHealthAssessment, SummaryItem } from '../../../../shared/interfaces/lead-details.service-types';
import { ChartModule } from 'primeng/chart';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { MEMBER_VIEW_PAGE_IDS } from '../../../../shared/constants/page.constants';
import { EditpdfComponent } from "../../../editpdf/editpdf.component";
import { PDFFormConfig } from '../../../../interfaces/config';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { CheckListService } from '../../../../services/check-list.service';
import { ChecklistResponse, DownloadFormPayload, DownloadFormPayloadItem } from '../../../../interfaces/checklist.model';
import { HttpResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { LeadDetailSummaryTrainingTileComponent } from '../lead-detail-summary-training-tile/lead-detail-summary-training-tile.component';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { UserService } from '../../../../services/user.service';
import { EnrollmentDataService } from 'src/app/services/enrollment-data.service';
import { ChecklistHelperService } from 'src/app/services/checklist.helper.service';
import { ListService } from 'src/app/shared/services/list.service';
import { DateTimeFormatterService } from 'src/app/shared/utils/date-time-formatter.service';
import { StorageService } from 'src/app/services/storage.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ENDPOINTS } from 'src/app/shared/constants/url.constants';
import { formatUrl } from 'src/app/shared/utils/format-url-util';
import { ToDoService } from 'src/app/services/to-do.service';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';

@Component({
  selector: 'ppl-lead-detail-summary',
  standalone: true,
  imports: [AccordionComponent, AuthorizeDirective, ChartModule, NgZorroModule, EditpdfComponent, CommonModule, LeadDetailSummaryTrainingTileComponent, DropdownSelectComponent],
  templateUrl: './lead-detail-summary.component.html',
  styleUrl: './lead-detail-summary.component.css'
})
export class LeadDetailSummaryComponent implements OnInit, AfterViewInit {
  fieldsUpdated($event: any) {
    throw new Error('Method not implemented.');
  }
  private dialogSvc = inject(DialogService);
  @ViewChild('pdfDialog') pdfDialogRef!: TemplateRef<any>;
  @ViewChild('pbiReportDialog') pbiReportDialog!: TemplateRef<any>;

  @Input() readOnly = false;
  pageId = '';
  tabId = 'Summary';
  entry: string | null = '';
  selectedLead = 0;
  program!: Program;
  staticSummaryItems: SummaryItem[] = [];
  summaryItems: SummaryItem[] = [];
  staticAuthorizationItems: SummaryItem[] = [];
  authorizationItems: SummaryItem[] = [];
  staticApplicationInfoItems: SummaryItem[] = [];
  applicationInfoItems: SummaryItem[] = [];
  weeklyUtilizationData: any = [];
  chartData: any;
  chartOptions: any;
  totalEarnings !: number;
  services = [
    {
      label: 'Support Broker Services',
      value: 'Support Broker Services'
    }
  ]

  participants = [
    {
      label: 'Nikhil',
      value: 'Nikhil'
    }
  ]

  payperiods = [
    {
      label: 'Nov 2, 2024 - Nov 14, 2024',
      value: 'Nov 2, 2024 - Nov 14, 2024'
    }
  ];
  pdfConfig?: PDFFormConfig;
  pdfFile?: string;
  pdfBlob?: Blob;
  showModal = false;
  modalBody = {
    associationModal: '',
    pdfViewer: ''
  };
  isParticipantFlow = false;
  isProviderFlow = false;
  isPA = false;
  associationMap: { typeCode: string; typeValue: string }[] = [];
  isDataLoaded: boolean = false;
  isWeeklyUtilizationSummaryPresent = false;
  isSameMco = true;
  wotcUrl: any;
  isPAOfferLetterDataLoaded: boolean = false;
  noOfPWCompleted: string = '';
  totalOfferLetters: string = '';
  filledInfo: any;
  viewDialogId: any;
  mobileHealthScheduleLink: string = '';
  healthAssessmentData: ProviderHealthAssessment[] | null = null;
  isHealthAssessmentDue: boolean = true;
  latestHealthAssessmentStatus: string = '';
  isHrStaff: boolean = false;
  timesheetPendingCount: number = 0;
  timesheetCompletedCount: number = 0;
  // Participant association checklists and the linked Employer/Provider checklists are two
  // independent requests that both feed the associations bucket, so each keeps its own subtotal
  // and the bucket is derived — otherwise whichever response landed last would clobber the other.
  private associationGroupsPendingCount: number = 0;
  private associationGroupsCompletedCount: number = 0;
  private linkedGroupsPendingCount: number = 0;
  private linkedGroupsCompletedCount: number = 0;
  todoListPendingCount: number = 0;
  todoListCompletedCount: number = 0;
  serviceCredentialsPendingCount: number = 0;
  serviceCredentialsCompletedCount: number = 0;
  isIF: boolean = false;
  adpSsoId: string = '';
  ADP_W2_LINK: string = ENDPOINTS.ADP.DOWNLAOD_W2;
  canViewW2 = true;
  canViewWorkHoursSummary = false;
  selectedPbiMonths: string = '';
  pbiDropdownOptions = [
    { attribute_text: '3 months', value: '3' },
    { attribute_text: '6 months', value: '6' },
    { attribute_text: '9 months', value: '9' },
    { attribute_text: '12 months', value: '12' },
    { attribute_text: '18 months', value: '18' },
    { attribute_text: '24 months', value: '24' },
  ];

  constructor(
    protected router: Router,
    private leadDetailsService: LeadDetailsService,
    private sectionService: SectionsService,
    private checkListService: CheckListService,
    private checkListHelperService: ChecklistHelperService,
    private userService: UserService,
    private enrollmentDataService: EnrollmentDataService,
    private listService: ListService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private storageService: StorageService,
    private sharedService: SharedService,
    private toDoService: ToDoService,
    private authUtility: AuthorizationUtility
  ) { }


  ngOnInit(): void {
    const providerType = this.getEnrollmentType();
    if (providerType == 'provider') {
      this.isPA = true;
    }
    if (providerType == 'independentFacilitator') {
      this.isIF = true;
    }

    const assocaitionTypes = this.sectionService.getEnrollmentType();
    if (assocaitionTypes.includes(ENROLLMENT_TYPE_BACKEND_MAPPINGS.IF) 
      || assocaitionTypes.includes(ENROLLMENT_TYPE_BACKEND_MAPPINGS.PA
      || assocaitionTypes.includes(ENROLLMENT_TYPE_BACKEND_MAPPINGS.VE)
    || assocaitionTypes.includes(ENROLLMENT_TYPE_BACKEND_MAPPINGS.IC))) {
      this.canViewWorkHoursSummary = true;
    }

    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    this.canViewW2 = this.pageId ? this.authUtility.isSectionVisible(this.pageId, 'PayStubs', 'W2') : true;
    this.entry = this.userService.getLeadEntry() ?? '';
    this.isParticipantFlow = this.userService.getLeadEntry() == 'participantEnrollment' || this.sectionService.getFlow() == 'participantEnrollment';
    this.isProviderFlow = this.entry === 'providerEnrollment';
    this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    this.program = this.userService.getSelectedProgram()!;
    this.getStaticSummaryItems();
    this.wotcUrl = environment.wotcUrl;
    const userRoles = this.userService.getUserDetails()?.programs.find(pr => pr.program_code === this.program?.program_code)?.roles;
    this.isHrStaff = userRoles ? userRoles?.some(r => r.role_name === 'PPL HR Staff') : false;

    if (this.isPA) {
      this.getOfferLetterCount();
    }

    this.chartData = {
      labels: ['Submitted', 'Approved', 'Processing for Payment', 'Paid'],
      datasets: [
        {
          data: [0, 0, 1628.8, 254.5],
          backgroundColor: ['#b44bff', '#ffbd3e', '#4abaff', '#ff5f47'],
          hoverBackgroundColor: ['#b44bff', '#ffbd3e', '#4abaff', '#ff5f47']
        }
      ]
    };

    // Calculate total earnings
    this.totalEarnings = this.chartData.datasets[0].data.reduce((a: number, b: number) => a + b, 0);

    // Chart options configuration
    this.chartOptions = {
      plugins: {
        datalabels: {
          display: true,
          color: '#000', // Set label color
          font: {
            weight: 'bold',
            size: 14 // Customize font size as needed
          },
          formatter: (value: any, context: any) => `${context.chart.data.labels[context.dataIndex]}: $${value.toFixed(2)}`
        },
        legend: {
          position: 'right',
          labels: {
            font: {
              size: 14
            },
            color: '#666',
            formatter: (value: any, context: any) => `${context.chart.data.labels[context.dataIndex]}: $${value.toFixed(2)}`
          }
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem: any) => {
              const label = this.chartData.labels[tooltipItem.dataIndex];
              const value = this.chartData.datasets[0].data[tooltipItem.dataIndex];
              return `$${value} ${label}`;
            }
          }
        }
      }
    };

    this.mobileHealthScheduleLink = environment.mobileHealthUrl;

    this.getChecklistTodoListCount();

    if (this.isIF) {
      this.getServiceCredentialTodoListCount();
    }

    if (this.isParticipantFlow) {
      this.getTimesheetPendingTodoListCount([{
        "jsonPath": "participantId",
        "value": this.selectedLead.toString(),
        "operator": "Equal"
      }]);
      this.getTimesheetCompletedTodoListCount([{
        "jsonPath": "participantId",
        "value": this.selectedLead.toString(),
        "operator": "Equal"
      }]);
    }

    if (!this.isParticipantFlow) {
      this.getProviderAssociationsCount();
      this.getLinkedChecklistsCount();
      this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
        this.getProviderAssociationsCount();
      })
    }
  }

  ngAfterViewInit() {
    if (this.isPA) {
      this.getLeadData();
    }
  }

  getLeadData() {
    this.leadDetailsService.getUpdatedLeadData().pipe(take(1)).subscribe((data) => {
      this.filledInfo =
        data?.responsedata?.infoData;
    });
  }

  fetchSummaryItemCountData() {
    const userType = this.entry === 'participantEnrollment' ? 'participant' : 'provider';
    this.leadDetailsService.getEnrollmentSummary(this.program?.program_code ?? '', this.selectedLead, userType).subscribe({
      next: (data: any) => {
        console.log("summary response ", data);
        const associationItems: EnrollmentSummaryResponseItem[] = data?.responsedata?.associations;
        const authorizationItems: EnrollmentSummaryResponseItem[] = data?.responsedata?.authorizations;

        const applicationInfoItems: EnrollmentSummaryResponseItem[] = data?.responsedata?.applicationInfo;

        this.weeklyUtilizationData = this.parseWeeklyUtilizationData(data?.responsedata?.payPeriodUtilization);

        this.healthAssessmentData = data?.responsedata?.healthAssessments;

        if (this.healthAssessmentData && this.healthAssessmentData.length == 0) {
          this.latestHealthAssessmentStatus = "Pending";
          this.isHealthAssessmentDue = true;
        }
        // check first health assessment is expired via end date of first health assessment is less greater than today and value is pass
        if (this.healthAssessmentData && this.healthAssessmentData.length > 0) {
          const firstHealthAssessment = this.healthAssessmentData[0];
          this.isHealthAssessmentDue = !(firstHealthAssessment.end_date && new Date(firstHealthAssessment.end_date) >= new Date() && (firstHealthAssessment.value.toLowerCase().startsWith('pass')));
          if (firstHealthAssessment.end_date && new Date(firstHealthAssessment.end_date) < new Date()) {
            this.latestHealthAssessmentStatus = "Expired"
          } else if (firstHealthAssessment.value.toLowerCase().startsWith('pass')) {
            this.latestHealthAssessmentStatus = "Passed";
          }
          else if (firstHealthAssessment.value.toLowerCase().startsWith('fail')) {
            this.latestHealthAssessmentStatus = "Failed";
          }
          else {
            this.latestHealthAssessmentStatus = "Pending";
          }
        }

        let associationValueMap: Record<string, string> = {};
        let authorizationValueMap: Record<string, string> = {};

        let applicationValueMap: Record<string, string> = {};

        associationValueMap = associationItems.reduce((acc, cur) => {
          acc[cur.typeCode] = cur.typeValue;
          return acc;
        }, associationValueMap);

        this.associationMap = associationItems;

        this.summaryItems = this.staticSummaryItems.map(item => {
          return {
            ...item,
            summaryItemValue: associationValueMap[item.summaryItemKey] || 0
          }
        });

        this.summaryItems = this.summaryItems.filter(item => item.summaryItemValue !== 0);

        // participant specific properties
        if (authorizationItems) {

          authorizationValueMap = authorizationItems.reduce((acc, cur) => {
            acc[cur.typeName] = cur.typeValue;
            return acc;
          }, authorizationValueMap);

          this.authorizationItems = this.staticAuthorizationItems.map(item => {
            return {
              ...item,
              summaryItemValue: authorizationValueMap[item.summaryItemDisplayName] || 0
            }
          });
        }

        // participant specific properties
        if (applicationInfoItems) {
          applicationValueMap = applicationInfoItems.reduce((acc, cur) => {
            acc[cur.typeName] = cur.typeValue;
            return acc;
          }, applicationValueMap);

          this.applicationInfoItems = this.staticApplicationInfoItems.map(item => {
            return {
              ...item,
              summaryItemValue: applicationValueMap[item.summaryItemDisplayName] || '-'
            }
          })
        }

        this.isDataLoaded = true;
      },
      error: () => {
        console.log("error occured during calculating summary", this.staticSummaryItems);
        this.summaryItems = [...this.staticSummaryItems];
        this.isDataLoaded = true;
      }
    })
  }

  parseWeeklyUtilizationData(weeklyUtilizationData: any) {
    let parsedData: any = [];
    if (weeklyUtilizationData && weeklyUtilizationData.length > 0) {
      parsedData = weeklyUtilizationData.map((entry: any) => {
        return { mcoName: entry.orgName, serviceDescription: entry.svcCode, utilization: entry.usedUnits, utilizationPercent: entry.usedUnitsPercentage, hoursAndMinutes: entry.hoursAndMinutes };
      });
      this.isWeeklyUtilizationSummaryPresent = true;
    }

    return parsedData;
  }

  getOfferLetterCount() {
    this.isPAOfferLetterDataLoaded = false;
    this.leadDetailsService.getPAOfferLettersCount(this.program?.program_code ?? '', this.selectedLead).subscribe({
      next: (response: any) => {
        const { total, pwComplete } = response.responsedata;
        this.noOfPWCompleted = pwComplete;
        this.totalOfferLetters = total;
        this.isPAOfferLetterDataLoaded = true;
      },
      error: (err) => {
        console.log("error occured during PA Offer letter count", err);
        this.isPAOfferLetterDataLoaded = false;
      }
    });
  }

  async getStaticSummaryItems() {
    const summaryItemsData = await this.sectionService.getJsonConfigurationData(
      STATIC_JSON_DATA_PATH.ENROLLMENT_SUMMARY_ITEMS,
      this.entry
    );
    this.staticSummaryItems = summaryItemsData.summaryItems as SummaryItem[];
    this.staticAuthorizationItems = summaryItemsData.authorizationsItems as SummaryItem[];
    this.staticApplicationInfoItems = summaryItemsData.applicationInfoItems as SummaryItem[];
    this.fetchSummaryItemCountData();
  }

  getFormMasterId(association: string): number {
    return formMasterIdMap[association] ?? 0;
  }

  viewWelcomeLetter(associtation: any) {
    this.showModal = true;
    this.modalBody.pdfViewer = 'Welcome Letter (' + associtation.typeName + ')';

    const form = {
      formMasterId: this.getFormMasterId(associtation.typeCode),
      formDesc: 'Welcome Letter',
      form_name: 'Welcome Letter'
    };

    this.pdfConfig = {
      form_id: form.formMasterId + '',
      is_mandatory: false,
      form_description: form.formDesc,
      form_name: form.form_name,
      fields: []
    };
    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }

    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());


    this.loadPDF(form);
  }

  handleCancel() {
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
  }

  loadPDF(form: any) {
    this.checkListService.getPDF(this.program?.program_code ?? '', form.formMasterId, 'eng').subscribe((response: HttpResponse<Blob>) => {
      if (response.body) {
        const blob = new Blob([response.body], { type: response.body.type });
        this.pdfBlob = blob;
        this.pdfFile = window.URL.createObjectURL(blob);
      }
    });
  }

  handleDownload(associtation: any) {
    const pdfPayload: DownloadFormPayloadItem[] = [];
    let primaryId: any = '';
    if (this.entry === 'providerEnrollment') {
      primaryId = this.storageService.getProviderPPLId();
    } else if (this.entry === 'participantEnrollment') {
      primaryId = this.storageService.getParticipantPPLId();
    }

    const providerType = this.getEnrollmentType();
    const providerPplId = this.storageService.getProviderPPLId();
    const forms = [{
      formMasterId: this.getFormMasterId(associtation.typeCode),
      formDesc: 'Welcome Letter',
      form_name: 'Welcome Letter'
    }];

    forms.forEach(f => {
      if (f.formMasterId != 0) {
        const payload: any = {
          checkListItemDtlsId: 342,
          checkListItemId: 248,
          formId: f.formMasterId + '',
          languageCode: 'ENG',
          programCode: this.program?.program_code,
          prtcpntPrvdrIdAndTypes: [
            {
              userType: ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[providerType],
              primaryId: primaryId
            }
          ],
          source: 'provider',
        };

        pdfPayload.push(payload);
      }
    });

    const formPayload: DownloadFormPayload = {
      forms: [...pdfPayload]
    };

    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    this.checkListService.downloadPDFForm(formPayload, "Welcome_Letter_" + timestamp + '.zip');
  }

  getEnrollmentType() {
    const enrollTypeString = this.sectionService.getEnrollmentType();
    const enrollType = enrollTypeString ? enrollTypeString : '';
    let enrollmentType = this.sectionService.getProviderFlowType(enrollType);
    return enrollmentType;
  }

  navigateToForms() {
    this.sectionService.changeTab('forms');
    this.router.navigate(['/home/providerEnrollmentList/details/forms']);
  }

  handleLinkKeydown(event: KeyboardEvent, context: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (context === 'offerLetters' || context === 'formsTab') {
        this.navigateToForms();
      }
    }
  }

  openPbiReportPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Generate Report',
      okText: 'Save',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.pbiReportDialog,
      dialogConfig,
      () => this.handlepbiDownload(this.selectedPbiMonths),
      () => this.handleCancel()
    );
  }

  handlepbiDownload(months: any) {
    const providerId = this.storageService.getProviderPPLId();
    const reportPayload = {
      employeeId: providerId,
      programCode: this.program?.program_code,
      lookbackMonths: months
    }

    this.leadDetailsService.downloadPBIReport(reportPayload, "Bi_report" + '_forms.zip');
  }

  handlePopUpClose() {
    this.dialogSvc.closeDialog(this.viewDialogId);
    if (this.filledInfo) {
      this.filledInfo.isWotcCertified = true
    }
  }

  getUtilizationClass(utilization: number): string {
    if (utilization > 90) return 'high-util';
    if (utilization > 60 && utilization <= 90) return 'medium-util';
    return 'low-util';
  }

  getTimesheetPendingTodoListCount(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'consumerTodoList',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const timesheets = data.responsedata;
        this.timesheetPendingCount = timesheets.length;
      });
  }

  getTimesheetCompletedTodoListCount(filters: any) {
    const processedPayload = this.buildRequestPayload(
      'consumerTimesheetCompletedList',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const timesheets = data.responsedata;
        this.timesheetCompletedCount = timesheets.length;
      });
  }

  buildRequestPayload(pageName: string, searchParams: []) {
    if (searchParams.length == 0) {
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.program?.program_code,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: [],
    };
    return payload;
  }

  getChecklistTodoListCount() {
    this.checkListService.getChecklist(this.program?.program_code || '', this.selectedLead?.toString() || '', this.isParticipantFlow).subscribe((data: any) => {
      if (data.responsedata) {
        const checklist: ChecklistResponse = data.responsedata;
        if (checklist && checklist.checkList && checklist.checkList.length > 0) {
          const pendingCheckListData = this.checkListHelperService.buildToDoChecklist(checklist.checkList.filter(e => e.checkListStatus == 'P'), this.isParticipantFlow, true);
          const completedCheckListData = this.checkListHelperService.buildToDoChecklist(checklist.checkList.filter(e => e.checkListStatus == 'C'), this.isParticipantFlow, true);
          if (pendingCheckListData) {
            this.todoListPendingCount = pendingCheckListData.length;
          }
          if (completedCheckListData) {
            this.todoListCompletedCount = completedCheckListData.length;
          }
        }
      }
    });
  }

  getServiceCredentialTodoListCount() {
    this.toDoService.getServiceCredentialStatus(this.program?.program_code, this.selectedLead?.toString() || '')
      .subscribe((data: any) => {
        const entries = data?.responsedata ?? [];
        this.serviceCredentialsPendingCount = entries.filter((e: any) => (e.status || '').toLowerCase() === 'pending').length;
        this.serviceCredentialsCompletedCount = entries.filter((e: any) => (e.status || '').toLowerCase() === 'completed').length;
      });
  }

  /**
   * Linked Employer/Provider checklists contribute one To-Do entry per non-completed group, the
   * same rule the To Do list renders by, so the two stay matched.
   */
  getLinkedChecklistsCount() {
    this.toDoService.getLinkedChecklists(this.program?.program_code, this.selectedLead?.toString() || '')
      .subscribe((entries: any[]) => {
        const groups = entries.flatMap((entry: any) => entry.checklistGroups ?? []);
        this.linkedGroupsPendingCount = groups.filter((g: any) => !g.isCompleted).length;
        this.linkedGroupsCompletedCount = groups.filter((g: any) => g.isCompleted).length;
      });
  }

  getProviderAssociationsCount() {
    const isParticipant = this.entry === 'participantEnrollment';
    const participantId = !isParticipant ? this.storageService.getSelfEmployerParticipantId() : undefined;
    this.enrollmentDataService.getAssociationsDetails(this.program?.program_code, this.selectedLead?.toString() || '', isParticipant, false, participantId).subscribe((response: any) => {
      console.log(response.responsedata);
      const data = response?.responsedata;

      this.adpSsoId = data?.basicInfo?.adpSsoId;
      if (this.adpSsoId) {
        this.ADP_W2_LINK = formatUrl(ENDPOINTS.ADP.DOWNLAOD_W2, { adpSsoId: this.adpSsoId });
      }

      const associations = data?.participantAssociations ?? [];

      const uniqueAssociations: any[] = [
        ...new Map(
          associations
            .filter((e: any) => e.associationStatus != 'Disassociated')
            .map((assoc: any) => [`${assoc.participantId}-${assoc.providerType}`, assoc])
        ).values()
      ];

      if (uniqueAssociations.length === 0) {
        this.associationGroupsPendingCount = 0;
        this.associationGroupsCompletedCount = 0;
        return;
      }

      this.toDoService.getAssociationChecklists(this.program.program_code, uniqueAssociations)
        .subscribe((result: any[]) => {
          const allGroups = result.flatMap((assoc: any) => assoc.checklistGroups ?? []);
          // Each association with a pending On-Duty Meal Break form contributes one dedicated
          // pending to-do item (shown as its own line in the To Do list).
          const onDutyMealBreakPendingCount = result.filter((assoc: any) => assoc.onDutyMealBreakPending).length;
          const onDutyMealBreakCompletedCount = result.filter((assoc: any) => assoc.onDutyMealBreakCompleted).length;
          const hcbsFormPendingCount = result.filter((assoc: any) => assoc.hcbsFormPending).length;
          const hcbsFormCompletedCount = result.filter((assoc: any) => assoc.hcbsFormCompleted).length;
          this.associationGroupsPendingCount = allGroups.filter((g: any) => !g.isCompleted).length + onDutyMealBreakPendingCount + hcbsFormPendingCount;
          this.associationGroupsCompletedCount = allGroups.filter((g: any) => g.isCompleted).length + onDutyMealBreakCompletedCount + hcbsFormCompletedCount;
        });
    });
  }

  downloadW2(): void {
    this.sharedService.initiateAdpW2(this.adpSsoId).subscribe({
      next: (html: string) => {
        const blob = new Blob([html], { type: 'text/html' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      },
      error: (err) => console.error('W2 download failed', err)
    });
  }

  get associationsPendingCount(): number {
    return this.associationGroupsPendingCount + this.linkedGroupsPendingCount;
  }
  get associationsCompletedCount(): number {
    return this.associationGroupsCompletedCount + this.linkedGroupsCompletedCount;
  }

  get pendingTodoListCount(): number {
    return this.todoListPendingCount + this.timesheetPendingCount + this.associationsPendingCount + this.serviceCredentialsPendingCount;
  }
  get completedTodoListCount(): number {
    return this.todoListCompletedCount + this.timesheetCompletedCount + this.associationsCompletedCount + this.serviceCredentialsCompletedCount;
  }

  getCalculatedPtoHours(utilization: number): string {
    return this.dateTimeFormatterService.formatUnitsToHoursMinutes(utilization);
  }
}
